import React from 'react'
import { Button } from 'react95';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import { downloadResume } from '../../functions/customFunctions';
import './buttons.css'

const WindowButton = ({ purpose, task, setTasksVisibility, setActiveTask, setTaskSwitiching, setIsDraggable, displayingTask, handleMusicClose, setHelperDisplay, setProjectUrl}) => {
  const handle = (event) => {
    event.stopPropagation();
    switch (purpose) {
      case 'minimise':
        event.stopPropagation();
        setTaskSwitiching(true)
        setTasksVisibility((prevState) => ({
          ...prevState,
          [task]: 'collapse'
        }))
        setActiveTask(null);
        break;
      case 'close':
        if (handleMusicClose) {
          handleMusicClose();
        } else if (setProjectUrl) {
          setProjectUrl(null);
        }
        displayingTask(false, task)
        setTimeout(() => {
          setActiveTask(null);
        }, 0);
        break;
      case 'download':
        downloadResume().catch(() => window.alert('Não foi possível baixar o currículo. Tente a opção Abrir PDF no portfólio.'));
        break;
      case 'help':
        setHelperDisplay('block');
        break;
      default:
        break;
    }
  }
  const disablingDraggable = (event) => {
    event.stopPropagation();
    setActiveTask(task)
    setIsDraggable(false)
    setIsDraggable(true)
  }

  return (
    <Button 
      className={`${purpose}-button`} 
      aria-label={{ minimise: 'Minimizar janela', close: 'Fechar janela', download: 'Baixar currículo', help: 'Ajuda' }[purpose]}
      onClick={handle} 
      type="button"
      onMouseDown={disablingDraggable} 
      onTouchStartCapture={disablingDraggable}
      style={{ color: 'black' }} /* <-- CORREÇÃO AQUI: Garante que o texto fique legível */
    >
      {(() => {
        switch (purpose) {
          case 'minimise':
            return <span className='minimise-icon' aria-hidden="true" />;
          case 'close':
            return <CloseLineIcon />;
          case 'download':
            return 'Download';
          case 'help':
            return <span className='help-icon'>?</span>;
          default:
            return null;
        }
      })()}
    </Button>
  );
}

export default WindowButton
